// src/shared/types/logger.types.ts
export enum LogLevel {
    FATAL = 60,
    ERROR = 50,
    WARN = 40,
    INFO = 30,
    DEBUG = 20,
    TRACE = 10,
}

export enum LogCategory {
    SECURITY = "SECURITY",
    PERFORMANCE = "PERFORMANCE",
    BUSINESS = "BUSINESS",
    SYSTEM = "SYSTEM",
    ACCESS = "ACCESS",
    DATABASE = "DATABASE",
    EMAIL = "EMAIL",
}

export type ExtendedLogOptions = {
    category: LogCategory;
    koOrganizationId?: string;
    userId?: string;
    correlationId?: string;
    ip?: string;
    data?: unknown;
};

export type ErrorLogData = {
    errorName: string;
    errorMessage: string;
    stackTrace?: string;
    code?: string | number;
    details?: Record<string, unknown>;
};

/**
 * Request-/Job-Kontext, den der Logger automatisch an jede Zeile hängt. Befüllt
 * wird er ausschließlich per AsyncLocalStorage.run() in
 * src/server/common/correlationContext.ts; der Logger liest ihn über den dort
 * registrierten Context-Provider.
 */
export type LoggingContext = {
    correlationId?: string;
    koOrganizationId?: string;
    userId?: string;
    ip?: string;
};
